import {
    MODAL_SALES_SHOW,
    MODAL_SALES_HIDE,
} from './../constants/constants';

const initialState = {
    visible: false,
    modalProps: {
        titleImage: '',
        titleText: '',
        body: '',
        footer: '',
        buttons: [],
        okButtonText: 'Okay',
        okButtonEvent: () => { },
        cancelButtonText: '',
        showClose: true
    }
}

const modalSalesReducer = (state = initialState, action) => {
    switch (action.type) {
        case MODAL_SALES_SHOW:
            let modalProps = { ...initialState.modalProps };
            modalProps.titleImage = ('titleImage' in action.modalProps) ? action.modalProps.titleImage : initialState.modalProps.titleImage;
            modalProps.titleText = ('titleText' in action.modalProps) ? action.modalProps.titleText : initialState.modalProps.titleText;
            modalProps.body = ('body' in action.modalProps) ? action.modalProps.body : initialState.modalProps.body;
            modalProps.footer = ('footer' in action.modalProps) ? action.modalProps.footer : initialState.modalProps.footer;
            modalProps.buttons = ('buttons' in action.modalProps) ? action.modalProps.buttons : initialState.modalProps.buttons;
            modalProps.okButtonText = ('okButtonText' in action.modalProps) ? action.modalProps.okButtonText : initialState.modalProps.okButtonText;
            modalProps.okButtonEvent = ('okButtonEvent' in action.modalProps) ? action.modalProps.okButtonEvent : initialState.modalProps.okButtonEvent;
            modalProps.cancelButtonText = ('cancelButtonText' in action.modalProps) ? action.modalProps.cancelButtonText : initialState.modalProps.cancelButtonText;
            modalProps.showClose = ('showClose' in action.modalProps) ? action.modalProps.showClose : initialState.modalProps.showClose;

            return {
                visible: true,
                modalProps
            }

        case MODAL_SALES_HIDE:
            return initialState;

        default:
            return state
    }
}

export default modalSalesReducer;